import { SafeJSON } from './../../shared/safe-json';
import { Issue } from './../juvenile-case-sections/issue';

export class Events {
    private json: any;
    private key: string;

    private issueArr: any = [];
    private show = true;

    constructor(json: any, key: string) {
        this.json = json;
        this.key = key;
        this.populateIssueMap();
    }

    populateIssueMap(): any {
        let obj: any = SafeJSON.get('issueList', this.json);
        let index = '0';
        for (const issue of obj) {
            // Object.keys(obj).forEach(key => {
            let value = new Issue(issue, index);
            this.issueArr.push(value);
            // index = index+1;
            // });
        }
    }

    getEventKey(): string {
        return this.key;
    }

    getEventDate(): string {
        return SafeJSON.get('date', this.json);
    }

    getEventTime(): string {
        return SafeJSON.get('time', this.json);
    }

    getEventDescription(): string {
        return SafeJSON.get('eventDesc', this.json);
    }

    getEventTypeDescription(): string {
        return SafeJSON.get('typeDesc', this.json);
    }

    getEventOutcomeDescription(): string {
        return SafeJSON.get('eventOutcomeDesc', this.json);
    }

    getEventJudgeName(): string {
        return SafeJSON.get('presidingJudgeName', this.json);
    }

    getLocationId(): string {
        return SafeJSON.get('locationId', this.json);
    }

    /*     getEventCoutroomCode(): string{
            return SafeJSON.get('time', this.json);
        }

        getEventCoutroom(): string{
            return SafeJSON.get('time', this.json);
        } */

    getEventNotes(): string {
        return SafeJSON.get('notes', this.json);
    }

    getIssuesList(): any[] {
        return this.issueArr;
    }

    isShow(): boolean {
        return this.show;
    }

    setShow(flag: boolean): void {
        this.show = flag;
    }

    getKey(): string {
        return this.key;
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/juvenile/juvenile-case-sections/events.ts